import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="flex-1">
            <SectionTitle
              title="Why This Pandabuy Spreadsheet Hub Exists"
              subtitle="A better way to discover curated spreadsheet finds"
            />

            <article className="mt-8 space-y-5 text-foreground-700 leading-relaxed">
              <p className="text-sm md:text-base">
                Finding a reliable <strong>pandabuyspreadsheet</strong> that is actually worth your
                time has become nearly impossible. Most lists floating around Reddit, TikTok, and Discord
                suffer from the same problems — outdated links, messy formatting, unverified items, and
                zero quality filtering. You end up spending more time digging through broken spreadsheets
                than actually discovering products worth buying.
              </p>
              <p className="text-sm md:text-base">
                We built this <strong>pandabuy spreadsheet</strong> hub to solve exactly that. Every single
                category is manually curated and refreshed regularly. Our team cross-references multiple
                sources — from trending subreddits to viral TikTok hauls — to ensure our
                <strong> pandabuyspreadsheet </strong>
                database stays accurate, relevant, and packed with genuinely good finds. No dead links,
                no filler items, no outdated junk.
              </p>
              <p className="text-sm md:text-base">
                Whether you are hunting for budget sneaker alternatives, premium jacket replicas, or
                the latest viral accessories everyone is talking about, our structured
                <strong> pandabuy sheet </strong>
                categories make it effortless to browse. Each category is filtered by quality scores and
                updated on a rolling basis, so what you see is always fresh. This is the kind of
                <strong> pandabuyspreadsheet </strong>
                resource that the community has been asking for — organized, searchable, and actually usable.
              </p>
            </article>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Link
                to="/pandabuy-sheet-ultimate-guide"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-white text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Full SEO Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-6">
              <div>
                <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">1,000+</span>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Curated Items</p>
              </div>
              <div>
                <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">Daily</span>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Fresh Updates</p>
              </div>
              <div>
                <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">14</span>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Categories</p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[400px] shrink-0">
            <div className="relative rounded-2xl overflow-hidden aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Fashion%20influencer%20hands%20holding%20a%20tablet%20displaying%20shopping%20spreadsheet%20with%20stylish%20clothing%20items%20and%20accessories%20scattered%20on%20a%20white%20marble%20desk%20bright%20daylight%20from%20side%20window%20modern%20creator%20workspace%20editorial%20lifestyle%20photography%20clean%20professional%20aesthetic&width=800&height=1000&seq=about-section-v2&orientation=portrait"
                alt="Pandabuy spreadsheet curated lifestyle finds"
                title="PandaBuy Spreadsheet - Curated Finds Collection"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <div className="absolute top-4 left-4">
                <span className="px-3 py-1.5 rounded-full bg-white text-foreground-800 text-xs font-medium">
                  Curated Collection
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-white text-lg font-semibold">PandaBuy Spreadsheet Hub</p>
                <p className="text-white/70 text-sm">Updated 2026 Collection</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}